import React, { FC } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Spinner from "../../assets/Spinner.svg";

interface Props {
    topMargin?: string;
}

const useStyles = makeStyles(() =>
    createStyles({
        loaderContainer: {

        },
        overlay: {
            position: "fixed",
            top: "50%",
            background: "#fff",
            width: "100%",
            transform: "translateY(-50%)",
            opacity: "0.85",
            height: "100%"
        },
        spanner: {
            display: "flex"
        },
        "@keyframes rotation": {
            from: { transform: "rotate(0deg)" },
            to: { transform: "rotate(359deg)" }
        },
        loader: {
            animation: "$rotation 2s infinite linear",
            margin: (props:any) => props.topMargin
        }
    }
));

/**
 * Basic loading indicator to tell the user something is happening.
 *
 * @param props
 * @constructor
 */
const Loading: FC<Props> = (props = {}) => {
    const classes = useStyles(props);
    return (
        <div className={classes.loaderContainer}>
            <div className={classes.spanner}>
                <img
                    className={classes.loader}
                    src={Spinner}
                    alt="spinner icon"
                />
            </div>
        </div>
    );
};

export default Loading;
